/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum ApiTransactionListSortKind {
  Title = 'title',
  State = 'state',
  UpdatedAt = 'updatedAt',
  Organization = 'organization',
  AssignedTo = 'assignedTo'
}
